import { render } from "./UserErasurePanel.vue?vue&type=template&id=7ec857b0"
import script from "./UserErasurePanel.vue?vue&type=script&lang=js"
export * from "./UserErasurePanel.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__